import React, { FC, ReactElement } from 'react'
import './CertificatePaymentPreviewWrapper.scss'
import ProgressBarComponent from 'app_components/commons/progressBar'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent'

interface ICertificatePaymentPreviewWrapperProps {
  title: string
  progress: string
  cancelButtonText: string
  confirmButtonText: string
  onCancel: () => void
  onConfirm: () => void
  children: ReactElement
  handleSubmit: any
  isLoading?: boolean
  hideProgress?: boolean
}

const CertificatePaymentPreviewWrapper: FC<ICertificatePaymentPreviewWrapperProps> = ({
  title,
  progress,
  cancelButtonText,
  confirmButtonText,
  onCancel,
  onConfirm,
  children,
  handleSubmit,
  isLoading,
  hideProgress
}) => {
  return (
    <form className="certificate-payment-preview-wrapper--layout" onSubmit={handleSubmit}>
      <TextComponent className='certificate-payment-preview-wrapper--title'>{title}</TextComponent>
      {!hideProgress && (
        <ProgressBarComponent background='var(--primary)' progress={progress} />
      )}
      <div className='certificate-payment-preview-wrapper--content'>
        {children}
      </div>
      <div className='certificate-payment-preview-wrapper--buttons'>
        <ButtonComponent
          type="button"
          color='var(--secondary)'
          textTransform='none'
          fontSize='110%'
          onClick={onCancel}
          disabled={isLoading}
        >
          {cancelButtonText}
        </ButtonComponent>
        <ButtonComponent
          type="submit"
          textTransform='none'
          variant='secondary'
          fontSize='110%'
          onClick={onConfirm}
          loading={isLoading}
        >
          {confirmButtonText}
        </ButtonComponent>
      </div>
    </form>
  )
}

export default CertificatePaymentPreviewWrapper
